export const LOCALSTORAGE_defaultDocData = 'sandbox.demo.data';

export const LOCALSTORAGE_themeKey = 'sandbox.demo.theme';
